var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1133C14.0711 16.1133 15.75 14.4343 15.75 12.3633C15.75 10.2922 14.0711 8.61328 12 8.61328C9.92893 8.61328 8.25 10.2922 8.25 12.3633C8.25 14.4343 9.92893 16.1133 12 16.1133Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.36328H7.5C5.01472 3.36328 3 5.378 3 7.86328V16.8633C3 19.3486 5.01472 21.3633 7.5 21.3633H16.5C18.9853 21.3633 21 19.3486 21 16.8633V7.86328C21 5.378 18.9853 3.36328 16.5 3.36328Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.61328C17.4963 8.61328 18 8.1096 18 7.48828C18 6.86696 17.4963 6.36328 16.875 6.36328C16.2537 6.36328 15.75 6.86696 15.75 7.48828C15.75 8.1096 16.2537 8.61328 16.875 8.61328Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.ecc6cfddee7599963e05c74be132f817.svg";
export { ForwardRef as ReactComponent };